import { employeeSignInUrl } from '@features/employee-session';
import { EmptyState } from '@shared/ui';
import { useLocation } from 'react-router';

/**
 * Security screens need a second sign-in, against the employee pool. A plain
 * link, not a fetch: the BFF answers with a redirect to Cognito, and comes back
 * to the same path and query, so the filters survive the trip.
 */
export function EmployeeSignInPanel() {
    const { pathname, search } = useLocation();

    return (
        <EmptyState
            title="Sign in to see this log"
            description="This screen needs your Veevart Google account, on top of your Atelier sign-in."
            action={
                <a
                    href={employeeSignInUrl(`${pathname}${search}`)}
                    className="inline-flex items-center rounded-lg border border-transparent bg-brand px-4 py-2 text-[13.5px] font-semibold text-white shadow-sm hover:bg-brand-600"
                    data-testid="unidentified-refusals-sign-in"
                >
                    Sign in with your Veevart Google account
                </a>
            }
        />
    );
}

/** Signed in, without the permission. The server refuses regardless; this says why. */
export function PermissionRequiredPanel() {
    return (
        <EmptyState
            title="You do not have access to this log"
            description="Reading unidentified refusals needs the security analyst permission. Ask the platform team if you need it."
        />
    );
}
